export default __webpack_public_path__ + "static/media/bids5.ea073326.png";